import { useCurrentProject } from 'api/queries/projects';
import { selectUserContext } from 'core/userContext';
import { closeNav } from 'modules/nav/ducks/actions';
import { NAVBAR_PROJECT_SETTINGS, NavbarVariant } from 'modules/nav/types';
import { createNavbarLinks } from 'modules/nav/utils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { camelCase } from 'utils/stringHelpers';
import { List, Root } from './NavbarLinks.styled';
import { NavbarLink } from './NavbarLink';

export const NAVBAR_LINKS_IDS = {
  id: 'navbar-links',
  list: 'navbar-links-list',
};

export const NavbarLinks = ({ variant }: { variant: NavbarVariant }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const userContext = useSelector(selectUserContext);
  const { projectSettings } = useCurrentProject();

  const settings = {
    [NAVBAR_PROJECT_SETTINGS.enableAnonUserTracking]: !!projectSettings?.enableAnonUserTracking,
  };

  const formattedNavItems = createNavbarLinks(userContext, settings);

  /**
   * Listen to navigation changes and close drawer
   */
  useEffect(() => {
    dispatch(closeNav());
  }, [pathname]);

  return (
    <Root orientation="horizontal" id={NAVBAR_LINKS_IDS.id} data-test={NAVBAR_LINKS_IDS.id}>
      <List id={NAVBAR_LINKS_IDS.list} data-test={NAVBAR_LINKS_IDS.list}>
        {formattedNavItems.map((item) => (
          <NavbarLink
            item={item}
            key={camelCase(item.header)}
            pathname={pathname}
            variant={variant}
          />
        ))}
      </List>
    </Root>
  );
};
